import { styled, keyframes } from 'styled-components';

import { MobileSearchMenuHolder } from '#/components/MobileSearchMenu/MobileSearchMenu.styled';
import { colors, cssBreakpoints, shadows } from '#/theme/theme';

const dialogEnter = keyframes`
  from {
    translate: 0 20%;
    opacity: 0;
  }
`;

const overlayFadeIn = keyframes`
  from {
    background: transparent;
  }
`;

export const DialogOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 104;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(255, 255, 255, 0.3);

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    animation: ${overlayFadeIn} var(--transition);
  }
`;

export const DialogPanel = styled.div`
  width: 100%;
  height: 100dvh;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    animation: ${dialogEnter} var(--transition);
    max-width: 600px;
    height: auto;
    max-height: 80dvh;
    border: 1px solid ${colors.elementGrey};
    border-radius: 8px;
    background: white;
    overflow: hidden;
    box-shadow: ${shadows.highest};
  }

  ${MobileSearchMenuHolder} {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      position: relative;
      height: auto;
      max-height: 80dvh;
      overflow-y: auto;
    }
  }
`;
